import React from "react";

type FlagProps = {
  code: string;
  size?: "s" | "m" | "l";
  gradient?: string;
  hasBorder?: boolean;
  hasDropShadow?: boolean;
  hasBorderRadius?: boolean;
  className?: string;
  alt?: string;
};

export const Flag: React.FC<FlagProps> = ({
  code = "CA",
  size = "m",
  gradient = "",
  hasBorder = false,
  hasDropShadow = false,
  hasBorderRadius = true,
  className = "",
  alt,
}) => {
  const flagAlt = alt ?? `${code} flag`;
  const classes = [
    "flag",
    gradient,
    `size-${size}`,
    hasBorder ? "border" : "",
    hasDropShadow ? "drop-shadow" : "",
    hasBorderRadius ? "border-radius" : "",
    className ? className.replace(/\s\s+/g, " ").trim() : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classes}>
      <img
        src={`/flags/${size}/${code}.svg`}
        alt={flagAlt}
        width={size === "s" ? 16 : size === "m" ? 20 : 24}
        height={size === "s" ? 12 : size === "m" ? 15 : 18}
        loading="lazy"
        decoding="async"
      />
    </div>
  );
};

export default Flag;

